import axios from 'axios';
import { efefrg4rrrg323ffgfssw3e3ddadfw23 } from '../components/componentConst';
import { BEBase } from '../constants/app.constant';
import CryptoJS from 'crypto-js';
import ReconnectingWebSocket from 'reconnecting-websocket';

// Initialize connection status globally and early
window.chatConnectionStatus = window.chatConnectionStatus || 'disconnected';

const SECRET_KEY = efefrg4rrrg323ffgfssw3e3ddadfw23;

// Create Axios instance for chat API requests
const chatAxios = axios.create({
  baseURL: `${BEBase}chat/`,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Single unified WebSocket connection
let unifiedSocket = null;

// Global event names for consistency
export const EVENTS = {
  UNREAD_COUNT_UPDATE: 'unread-count-update',
  READ_RECEIPT: 'read-receipt',
  NEW_MESSAGE: 'new-message',
  USER_PRESENCE: 'user-presence',
  CONVERSATION_UPDATE: 'conversation-update',
  CONVERSATIONS_LIST: 'conversations-list',
  TYPING_INDICATOR: 'typing-indicator',
  ONLINE_USERS_LIST: 'online-users-list',
  CONNECTION_STATUS: 'connection-status',
  CONVERSATION_MESSAGES: 'conversation-messages',
  ACTIVE_CONVERSATION_CHANGED: 'active-conversation-changed',
  ERROR: 'error',
  CREATE_GROUP: 'create_group_conversation',
  UPDATE_GROUP: 'update_group_conversation',
  ADD_MEMBERS: 'add_conversation_members',
  REMOVE_MEMBERS: 'remove_conversation_members',
  LEAVE_CONVERSATION: 'leave_conversation',
  DELETE_CONVERSATION: 'delete_conversation',
  NOTIFICATION_SEND: 'notification.send',
  NOTIFICATION_UPDATED: 'notification.updated',
  NOTIFICATIONS_BULK_UPDATED: 'notifications.bulk_updated',
};

// Heartbeat interval (in milliseconds)
const HEARTBEAT_INTERVAL = 15000;
let heartbeatTimer = null;

// Track active conversations being viewed
let activeConversationId = null;
let eventHandlers = {};

// Helper function to decrypt data from localStorage
const decryptData = (encryptedData) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedString);
  } catch (error) {
    console.error('Decryption error:', error);
    return null;
  }
};

// Get authentication token from localStorage
export const getAuthToken = () => {
  const encryptedCreds = localStorage.getItem('loginCred');
  if (!encryptedCreds) return null;

  const decryptedCreds = decryptData(encryptedCreds);
  if (!decryptedCreds || !decryptedCreds.token) return null;

  return decryptedCreds.token;
};

// Configure Axios interceptors for authentication
chatAxios.interceptors.request.use(
  config => {
    const token = getAuthToken();
    if (token) {
      config.headers['Authorization'] = `Token ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// Dispatch a global event for inter-component communication
export const dispatchGlobalEvent = (eventName, detail) => {
  const event = new CustomEvent(eventName, { detail });
  window.dispatchEvent(event);
};

// Track connection state
let isConnecting = false;
const MAX_RECONNECT_ATTEMPTS = 10;
let reconnectTimer = null;

const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
const host = window.location.hostname === 'localhost' ? 'localhost:8000' : window.location.host;

// WebSocket base URL
const WSBase = `${protocol}//${host}/`;

// Safe JSON parsing with error handling
const safeParseJSON = (data) => {
  if (!data) return null;

  try {
    return JSON.parse(data);
  } catch (err) {
    console.error('Error parsing WebSocket message:', err);
    console.error('Raw message content:', typeof data === 'string' ? data.substring(0, 100) + '...' : data);
    return { type: 'error', message: 'Invalid JSON data' };
  }
};

/**
  Connection to Match Websocket
 */

/**
 * Connect to the unified WebSocket
 * @param {Object} handlers - Event handlers
 * @returns {WebSocket} WebSocket instance
 */
export const connectUnifiedWebSocket = (handlers = {}) => {
  // Store handlers for later use
  eventHandlers = { ...eventHandlers, ...handlers };

  // Prevent multiple simultaneous connection attempts
  if (isConnecting && unifiedSocket) {
    console.log("Already attempting to connect to unified WebSocket");
    return unifiedSocket;
  }

  isConnecting = true;

  // Clear any existing socket
  if (unifiedSocket) {
    try {
      unifiedSocket.close();
    } catch (err) {
      console.log("Error closing existing unified socket:", err);
    }
    unifiedSocket = null;
  }

  const token = getAuthToken();
  if (!token) {
    console.error("No auth token found for WebSocket connection");
    isConnecting = false;
    return null;
  }

  // Updated URL: Use query parameter for token instead of path parameter
  const wsUrl = `${WSBase}ws/chat/?token=${token}`;

  try {
    // Create new reconnecting socket
    unifiedSocket = new ReconnectingWebSocket(wsUrl, [], {
      connectionTimeout: 5000,
      maxRetries: MAX_RECONNECT_ATTEMPTS,
      minReconnectionDelay: 1000,
      maxReconnectionDelay: 30000,
      reconnectionDelayGrowFactor: 1.3
    });

    // Store the active conversation ID on the socket
    unifiedSocket.conversationId = activeConversationId;

    // Set up event handlers
    unifiedSocket.onopen = () => {
      console.log(`Unified WebSocket connected`);
      isConnecting = false;


      // Clear any pending reconnect timer
      if (reconnectTimer) {
        clearTimeout(reconnectTimer);
        reconnectTimer = null;
      }

      // Start sending heartbeats to keep connection alive
      startHeartbeat();

      // Update connection status
      updateConnectionStatus('connected');

      // When reconnecting, we need to immediately notify the server of our active conversation
      if (activeConversationId) {
        console.log(`Informing server of active conversation ${activeConversationId}`);
        // Send with minimal delay to ensure server processes it
        setTimeout(() => {
          if (unifiedSocket && unifiedSocket.readyState === WebSocket.OPEN) {
            unifiedSocket.send(JSON.stringify({
              type: 'set_active_conversation',
              conversation_id: activeConversationId
            }));
          }
        }, 100);
      }

      // Call handler if provided
      if (eventHandlers.onConnect) eventHandlers.onConnect();
    };

    unifiedSocket.onclose = (event) => {
      console.log(`Unified WebSocket closed: ${event.code} ${event.reason}`);
      stopHeartbeat();
      isConnecting = false;

      // Update connection status
      updateConnectionStatus('disconnected', event);

      // Call handler if provided
      if (eventHandlers.onDisconnect) eventHandlers.onDisconnect(event);
    };

    unifiedSocket.onerror = (error) => {
      console.error("Unified WebSocket error:", error);
      isConnecting = false;

      // Update connection status
      updateConnectionStatus('error', { error });

      // Call handler if provided
      if (eventHandlers.onError) eventHandlers.onError(error);
    };

    unifiedSocket.onmessage = (event) => {
      try {
        const data = safeParseJSON(event.data);

        // Skip processing if parsing failed
        if (!data) {
          console.error('Skipping invalid WebSocket message');
          return;
        }

        // Handle error messages from server
        if (data.type === 'error') {
          console.error('Server returned error:', data.message);
          dispatchGlobalEvent(EVENTS.ERROR, data);
          if (eventHandlers.onError) {
            eventHandlers.onError(new Error(data.message));
          }
          return;
        }

        const messageType = data.type;

        // Debug log for all incoming messages
        if (messageType !== 'pong') { // Reduce noise by excluding pong logs
          console.log(`WebSocket received: ${messageType}`, data);
        }

        // Respond to different message types
        switch (messageType) {
          case 'unread_count_update':
            dispatchGlobalEvent(EVENTS.UNREAD_COUNT_UPDATE, data);
            if (eventHandlers.onUnreadCountUpdate) eventHandlers.onUnreadCountUpdate(data);
            break;

          case 'chat_message':
            // Enhanced handling for chat messages
            if (data.message) {
              // Process the message content
              const message = data.message;
              const conversationId = data.conversation_id || message.conversation_id;

              // Normalize message format
              const normalizedMessage = {
                ...message,
                conversation_id: String(conversationId),
                sender_id: String(message.sender_id || '')
              };

              // Handle the incoming message
              handleIncomingMessage(normalizedMessage);

              // Also process delivery status for optimistic updates
              if (message.client_temp_id && eventHandlers.onMessageStatus) {
                eventHandlers.onMessageStatus({
                  client_temp_id: message.client_temp_id,
                  id: message.id,
                  status: 'delivered',
                  timestamp: data.timestamp || new Date().toISOString()
                });
              }
            }
            break;

          case 'read_receipt':
            dispatchGlobalEvent(EVENTS.READ_RECEIPT, data);
            if (eventHandlers.onReadReceipt) eventHandlers.onReadReceipt(data);
            break;

          case 'user_presence':
            dispatchGlobalEvent(EVENTS.USER_PRESENCE, {
              userId: data.user_id,
              status: data.status,
              timestamp: data.timestamp
            });
            if (eventHandlers.onUserPresence) eventHandlers.onUserPresence(data);
            break;

          case 'conversation_update':
            // Dispatch with consistent data structure
            dispatchGlobalEvent(EVENTS.CONVERSATION_UPDATE, {
              conversation: data.conversation,
              updateType: data.update_type || 'update'
            });
            if (eventHandlers.onConversationUpdate) {
              eventHandlers.onConversationUpdate({
                conversation: data.conversation,
                update_type: data.update_type || 'update'
              });
            }
            break;

          case 'conversations_list':
            // Record timestamp when conversations were received for timeout checking
            window.lastConversationsReceived = Date.now();

            // Add validation to ensure the conversations array exists
            if (!data.conversations || !Array.isArray(data.conversations)) {
              console.error('Received invalid conversations list format:', data);
              data.conversations = []; // Ensure empty array if missing
            }

            // Fix any invalid conversation objects
            if (Array.isArray(data.conversations)) {
              data.conversations = data.conversations.filter(conv => {
                // Filter out any invalid conversation objects
                if (!conv || typeof conv !== 'object' || !conv.id) {
                  console.warn('Filtering out invalid conversation object:', conv);
                  return false;
                }
                return true;
              });
            }

            // Handle receiving the full conversations list
            dispatchGlobalEvent(EVENTS.CONVERSATIONS_LIST, data);
            if (eventHandlers.onConversationsList) {
              console.log(`Received ${data.conversations?.length || 0} conversations`);
              eventHandlers.onConversationsList(data);
            }
            break;

          case 'online_users_list':
            dispatchGlobalEvent(EVENTS.ONLINE_USERS_LIST, data.users);
            if (eventHandlers.onOnlineUsersList) eventHandlers.onOnlineUsersList(data.users);
            break;

          case 'typing_indicator':
            handleTypingIndicator(data);
            break;

          case 'pong':
            // Server responded to our ping - connection is alive
            // Update the global status for others to access
            window.chatConnectionStatus = 'connected';
            break;

          case 'conversation_read':
            // Handle when a conversation is marked as read
            dispatchGlobalEvent(EVENTS.CONVERSATION_READ, data);
            if (eventHandlers.onConversationRead) eventHandlers.onConversationRead(data);
            break;

          case 'status_update':
            // Handle message status updates
            dispatchGlobalEvent(EVENTS.STATUS_UPDATE, data);
            if (eventHandlers.onStatusUpdate) eventHandlers.onStatusUpdate(data);
            break;

          case 'conversation_messages':
            console.log(`Received ${data.messages?.length || 0} messages for conversation ${data.conversation_id}`);

            // Add request_id to event detail if available
            const detail = {
              conversation_id: data.conversation_id,
              messages: data.messages || [],
              page: data.page || 1,
              total_messages: data.total_messages || data.messages?.length || 0,
              timestamp: data.timestamp,
              request_id: data.request_id
            };

            // Dispatch both event types for backward compatibility
            dispatchGlobalEvent(EVENTS.CONVERSATION_MESSAGES, detail);
            dispatchGlobalEvent('conversation_messages', detail);

            if (eventHandlers.onConversationMessages) {
              eventHandlers.onConversationMessages(detail);
            }
            break;

          case 'active_conversation_changed':
            console.log(`Server confirmed active conversation change to ${data.conversation_id}`);
            dispatchGlobalEvent(EVENTS.ACTIVE_CONVERSATION_CHANGED, data);
            if (eventHandlers.onActiveConversationChanged) {
              eventHandlers.onActiveConversationChanged(data);
            }
            break;

          case 'message_status':
            // Process status updates for sent messages
            dispatchGlobalEvent(EVENTS.MESSAGE_STATUS, data);
            if (eventHandlers.onMessageStatus) {
              eventHandlers.onMessageStatus(data);
            }
            break;

          case 'popup_notification':
            dispatchGlobalEvent('popup-notification', data);
            if (eventHandlers.onPopupNotification) {
              eventHandlers.onPopupNotification(data);
            }
            break;

          case 'group_updated':
            console.log(`Group ${data.conversation_id} updated`);
            dispatchGlobalEvent('group-updated', data);
            break;

          case 'group_member_added':
            console.log(`Member ${data.user_id} added to group ${data.conversation_id}`);
            dispatchGlobalEvent('group-member-added', data);
            break;

          case 'group_member_removed':
            console.log(`Member ${data.user_id} removed from group ${data.conversation_id}`);
            dispatchGlobalEvent('group-member-removed', data);
            break;

          case 'group_left':
            console.log(`User left group ${data.conversation_id}`);
            dispatchGlobalEvent('group-left', data);
            break;

          // Add the missing notification handlers
          case EVENTS.NOTIFICATION_SEND:
            console.log(`Recieved ${data.tyoe} notifications ${data.notification}`);
            dispatchGlobalEvent(EVENTS.NOTIFICATION_SEND, data);
            break;
          case EVENTS.NOTIFICATION_UPDATED:
            if (handlers.onNotificationUpdated && data.notification) {
              handlers.onNotificationUpdated(data.notification);
            }
            break;
          case EVENTS.NOTIFICATIONS_BULK_UPDATED:
            if (handlers.onNotificationsBulkUpdated) {
              handlers.onNotificationsBulkUpdated(data);
            }
            break;
          case 'error':
            console.error('WebSocket error message from server:', data.message);
            if (handlers.onError) handlers.onError(new Error(data.message));
            dispatchGlobalEvent('websocketServerError', { message: data.message });
            break;
          default:
            console.warn('Unhandled WebSocket message type:', data.type, data);
        }
      } catch (err) {
        console.error("Error processing WebSocket message:", err);
      }
    };

    return unifiedSocket;
  } catch (err) {
    console.error("Failed to create unified WebSocket:", err);
    isConnecting = false;
    updateConnectionStatus('error', { error: err });
    return null;
  }
};

/**
 * Ensure only one WebSocket connection exists
 * @param {Object} handlers - Event handlers
 * @returns {WebSocket} WebSocket instance
 */
export const ensureSingleWebSocketConnection = (handlers = {}) => {
  // If we already have a connected socket, just update handlers and return it
  if (unifiedSocket &&
    (unifiedSocket.readyState === WebSocket.OPEN ||
      unifiedSocket.readyState === WebSocket.CONNECTING)) {
    console.log("Using existing WebSocket connection");
    // Update handlers
    eventHandlers = { ...eventHandlers, ...handlers };
    return unifiedSocket;
  }

  // Create new connection if needed
  console.log("Creating new WebSocket connection");
  return connectUnifiedWebSocket(handlers);
};

/**
 * Update the current active conversation ID and inform the WebSocket server
 * @param {string|number} conversationId - The conversation ID to set as active
 * @returns {Promise<boolean>} Success status
 */
export const setActiveConversation = async (conversationId) => {
  // Update the local state tracking active conversation
  console.log(`Setting active conversation to ${conversationId || 'none'}`);

  // Make sure we have a consistent format for comparison
  if (conversationId !== null) {
    activeConversationId = String(conversationId);
  } else {
    activeConversationId = null;
  }

  // Ensure we have a connection before sending
  if (!unifiedSocket || unifiedSocket.readyState !== WebSocket.OPEN) {
    console.log("WebSocket not connected, establishing connection first");
    // Create a new connection if needed
    unifiedSocket = ensureSingleWebSocketConnection(eventHandlers);

    // Wait for connection to establish with timeout
    if (unifiedSocket && unifiedSocket.readyState !== WebSocket.OPEN) {
      console.log("Waiting for WebSocket connection to establish...");
      try {
        await new Promise((resolve, reject) => {
          const timeoutId = setTimeout(() => {
            reject(new Error("WebSocket connection timeout"));
          }, 5000);

          const openHandler = () => {
            clearTimeout(timeoutId);
            resolve();
            unifiedSocket.removeEventListener('open', openHandler);
          };

          const errorHandler = (err) => {
            clearTimeout(timeoutId);
            reject(err);
            unifiedSocket.removeEventListener('error', errorHandler);
          };

          unifiedSocket.addEventListener('open', openHandler);
          unifiedSocket.addEventListener('error', errorHandler);
        });
      } catch (err) {
        console.error("Error waiting for WebSocket connection:", err);
        return false;
      }
    }
  }

  // At this point, check if connection is open
  if (unifiedSocket && unifiedSocket.readyState === WebSocket.OPEN) {
    try {
      console.log(`Sending set_active_conversation with ID ${activeConversationId}`);

      // Create a promise to wait for server acknowledgment
      const ackPromise = new Promise((resolve, reject) => {
        const timeoutId = setTimeout(() => {
          reject(new Error("Timeout waiting for active conversation confirmation"));
        }, 5000);

        const handler = (event) => {
          const data = event.detail;
          if (data.conversation_id === conversationId) {
            clearTimeout(timeoutId);
            window.removeEventListener(EVENTS.ACTIVE_CONVERSATION_CHANGED, handler);
            resolve(true);
          }
        };

        window.addEventListener(EVENTS.ACTIVE_CONVERSATION_CHANGED, handler);
      });

      // Send message to server indicating active conversation change
      unifiedSocket.send(JSON.stringify({
        type: 'set_active_conversation',
        conversation_id: activeConversationId
      }));

      // Update the tracked ID on the socket object
      unifiedSocket.conversationId = activeConversationId;

      // Debugging: Add global object for tracking
      window.currentActiveConversation = activeConversationId;

      // Wait for acknowledgment with timeout protection
      try {
        await ackPromise;
        return true;
      } catch (err) {
        console.warn("No explicit acknowledgment received for active conversation change, but proceeding anyway");
        return true; // Continue anyway to avoid blocking UI
      }
    } catch (error) {
      console.error("Error updating active conversation:", error);
      return false;
    }
  } else {
    console.error("WebSocket not open, can't set active conversation");
    return false;
  }
};

/**
 * Handle incoming messages from WebSocket with improved handling
 * @param {Object} message - The message data
 */
function handleIncomingMessage(message) {
  // Skip processing if message lacks essential data
  if (!message || !message.conversation_id) {
    console.error("Received invalid message data:", message);
    return;
  }

  // Ensure we have consistent data types for comparison
  const normalizedMessage = {
    ...message,
    sender_id: String(message.sender_id || ''),
    conversation_id: String(message.conversation_id)
  };

  // Add receipt time for tracking
  normalizedMessage.received_at = new Date().toISOString();

  // Add client-side tracking ID if not present
  if (!normalizedMessage.id && !normalizedMessage.client_temp_id) {
    normalizedMessage.client_temp_id = `client_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
  }

  console.log(`Processing message for conversation ${normalizedMessage.conversation_id}`);

  // Dispatch global event for this message
  dispatchGlobalEvent(EVENTS.NEW_MESSAGE, normalizedMessage);

  // Also dispatch as custom event that components can listen for
  window.dispatchEvent(new CustomEvent('chat-message-received', {
    detail: normalizedMessage
  }));

  // If this is a response to a client_temp_id, dispatch explicit status update
  if (normalizedMessage.client_temp_id && normalizedMessage.id) {
    dispatchGlobalEvent(EVENTS.MESSAGE_STATUS, {
      client_temp_id: normalizedMessage.client_temp_id,
      id: normalizedMessage.id,
      conversation_id: normalizedMessage.conversation_id,
      status: 'delivered',
      timestamp: new Date().toISOString()
    });
  }

  // Call handler if provided
  if (eventHandlers.onMessage) {
    eventHandlers.onMessage(normalizedMessage);
  }

  // For messages not from current user and in current conversation, mark as read
  if (normalizedMessage.id &&
    normalizedMessage.sender_id !== String(window.currentUserId) &&
    normalizedMessage.conversation_id === String(activeConversationId)) {

    // Send read receipt automatically
    sendReadReceipt(normalizedMessage.id, normalizedMessage.conversation_id);
  }
}

/**
 * Keep track of typing users per conversation
 */
const typingUsersMap = new Map();

/**
 * Handle typing indicator messages
 * @param {Object} data - The typing indicator data
 */
function handleTypingIndicator(data) {
  if (!data) {
    console.error("Received empty typing indicator data");
    return;
  }

  const { user_id, is_typing, conversation_id, active_typing_users } = data;

  // Get conversation ID from the data or fall back to active conversation ID
  const conversationId = conversation_id || activeConversationId;
  if (!conversationId) {
    console.warn("Cannot process typing indicator: No active conversation ID");
    return;
  }

  // Initialize typing users set for this conversation
  if (!typingUsersMap.has(conversationId)) {
    typingUsersMap.set(conversationId, new Set());
  }

  // Get typing users for this conversation
  const typingUsers = typingUsersMap.get(conversationId);

  // If server provides active typing users list, use it (most reliable)
  if (Array.isArray(active_typing_users)) {
    // Clear existing and add all from the list
    typingUsers.clear();
    active_typing_users.forEach(userId => typingUsers.add(String(userId)));
  }
  // Otherwise update based on individual user typing status
  else if (user_id !== undefined && is_typing !== undefined) {
    if (is_typing) {
      typingUsers.add(String(user_id));
    } else {
      typingUsers.delete(String(user_id));
    }
  }

  // Dispatch global event with typing information
  dispatchGlobalEvent(EVENTS.TYPING_INDICATOR, {
    userId: user_id ? String(user_id) : undefined,
    conversationId: conversationId,
    isTyping: is_typing,
    activeTypingUsers: Array.from(typingUsers)
  });

  // Call handler if provided
  if (eventHandlers.onTyping) {
    eventHandlers.onTyping(data);
  }
}

/**
 * Update connection status and dispatch events
 * @param {string} status - Connection status: 'connected', 'disconnected', 'connecting', 'reconnecting', 'failed', 'error'
 * @param {Object} data - Additional data about the status
 */
function updateConnectionStatus(status, data = {}) {
  // Store status in window for global access
  window.chatConnectionStatus = status;

  // Dispatch event for status change
  dispatchGlobalEvent(EVENTS.CONNECTION_STATUS, { status, ...data });
}

/**
 * Send a typing indicator
 * @param {boolean} isTyping - Whether the user is typing
 * @param {string|number} conversationId - The conversation ID
 * @returns {boolean} Success status
 */
export const sendTypingIndicator = (function () {
  // Closure variables to track typing state
  let typingTimeoutId = {};
  let lastTypingState = {};

  return function (isTyping, conversationId) {
    // Require conversation ID
    if (!conversationId) {
      console.error('Cannot send typing indicator: No conversation ID provided');
      return false;
    }

    const convIdStr = String(conversationId);

    // Check WebSocket connection
    if (!unifiedSocket || unifiedSocket.readyState !== WebSocket.OPEN) {
      console.error('Cannot send typing indicator: WebSocket not connected');
      return false;
    }

    try {
      const currentState = lastTypingState[convIdStr] || false;

      // Only send if state is changing to prevent unnecessary traffic
      if (isTyping !== currentState) {
        console.log(`Sending typing=${isTyping} for conversation ${convIdStr}`);
        unifiedSocket.send(JSON.stringify({
          type: 'typing_indicator',
          is_typing: isTyping,
          conversation_id: convIdStr
        }));

        lastTypingState[convIdStr] = isTyping;

        // Clear existing timer for this conversation
        if (typingTimeoutId[convIdStr]) {
          clearTimeout(typingTimeoutId[convIdStr]);
          delete typingTimeoutId[convIdStr];
        }

        // Set timeout to auto-reset typing state if isTyping=true
        if (isTyping) {
          typingTimeoutId[convIdStr] = setTimeout(() => {
            // Auto-send typing=false after timeout if state is still true
            if (lastTypingState[convIdStr] === true && unifiedSocket?.readyState === WebSocket.OPEN) {
              console.log(`Auto-sending typing=false for ${convIdStr} after timeout`);
              unifiedSocket.send(JSON.stringify({
                type: 'typing_indicator',
                is_typing: false,
                conversation_id: convIdStr
              }));
              lastTypingState[convIdStr] = false;
            }
            delete typingTimeoutId[convIdStr];
          }, 5000);
        }
      }
      return true;
    } catch (error) {
      console.error('Error sending typing indicator:', error);
      return false;
    }
  };
})();

/**
 * Start sending heartbeat pings to keep the connection alive
 */
function startHeartbeat() {
  stopHeartbeat();

  // Track ping responses to monitor connection health
  let lastPongReceived = Date.now();

  heartbeatTimer = setInterval(() => {
    if (unifiedSocket && unifiedSocket.readyState === WebSocket.OPEN) {
      // Check if we've received responses for our recent pings
      const pingTimeout = 15000; // 15 seconds
      const now = Date.now();

      // If no pong received recently, consider connection unhealthy
      if (now - lastPongReceived > pingTimeout * 2) {
        console.warn("No ping response received for too long, connection might be unhealthy");
        // Update connection status to indicate potential issues
        updateConnectionStatus('unhealthy');
      }

      console.debug('Sending heartbeat ping');
      unifiedSocket.send(JSON.stringify({
        type: 'ping',
        timestamp: new Date().toISOString()
      }));

      // Add a specific event handler for pong response
      const pongHandler = (event) => {
        try {
          const data = safeParseJSON(event.data);
          if (data && data.type === 'pong') {
            lastPongReceived = Date.now();
            // Confirm connection is healthy when we receive a pong
            updateConnectionStatus('connected');
            // Remove this specific handler after processing
            unifiedSocket.removeEventListener('message', pongHandler);
          }
        } catch (err) {
          // Do nothing on parse error for pong handler
        }
      };

      // Add temporary listener specifically for this ping's pong
      unifiedSocket.addEventListener('message', pongHandler);

      // Remove the handler if no response after timeout
      setTimeout(() => {
        unifiedSocket.removeEventListener('message', pongHandler);
      }, pingTimeout);

    } else {
      console.warn('Cannot send heartbeat - WebSocket not connected');
      updateConnectionStatus('disconnected');
    }
  }, HEARTBEAT_INTERVAL);
}

/**
 * Stop the heartbeat timer
 */
function stopHeartbeat() {
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer);
    heartbeatTimer = null;
  }
}

/**
 * Disconnect the WebSocket
 */
export const disconnectWebSocket = () => {
  stopHeartbeat();

  if (unifiedSocket) {
    try {
      console.log("Disconnecting unified WebSocket");

      if (unifiedSocket.readyState === WebSocket.OPEN ||
        unifiedSocket.readyState === WebSocket.CONNECTING) {
        unifiedSocket.close(1000, "User-initiated disconnect");
      }
    } catch (err) {
      console.error("Error closing WebSocket:", err);
    } finally {
      unifiedSocket = null;
      activeConversationId = null;
      updateConnectionStatus('disconnected');
    }
    return true;
  }
  return false;
};

/**
 * Send a read receipt
 * @param {number|string} messageId - The message ID
 * @param {number|string} conversationId - The conversation ID (optional if active conversation is set)
 * @returns {boolean} Success status
 */
export const sendReadReceipt = (function () {
  const pendingReadReceipts = new Set();
  const BATCH_DELAY = 300; // Milliseconds to wait before sending batch
  let batchTimer = null;
  let receiptBatch = new Map(); // Store receipts as { conversationId: Set<messageId> }

  const sendBatch = () => {
    if (receiptBatch.size === 0) return;

    console.log(`Sending batched read receipts:`, receiptBatch);

    if (!unifiedSocket || unifiedSocket.readyState !== WebSocket.OPEN) {
      console.warn("WebSocket not connected for read receipt, clearing batch");
      receiptBatch.clear();
      batchTimer = null;
      return;
    }

    receiptBatch.forEach((messageIds, conversationId) => {
      messageIds.forEach(messageId => {
        const receiptKey = `${conversationId}-${messageId}`;
        try {
          console.log(`Sending read receipt for msg ${messageId} in conv ${conversationId}`);
          unifiedSocket.send(JSON.stringify({
            type: 'read_receipt',
            message_id: messageId,
            conversation_id: conversationId
          }));
        } catch (e) {
          console.error("Error sending read receipt:", e);
        } finally {
          // Remove from pending set after sending
          pendingReadReceipts.delete(receiptKey);
        }
      });
    });

    // Clear the batch and timer
    receiptBatch.clear();
    batchTimer = null;
  };

  return function (messageId, conversationId) {
    if (!messageId) {
      console.error("Invalid message ID for read receipt");
      return false;
    }

    // Use provided conversation ID or active one
    const convId = conversationId || activeConversationId;
    if (!convId) {
      console.error("Missing conversation ID for read receipt");
      return false;
    }

    const receiptKey = `${convId}-${messageId}`;
    if (pendingReadReceipts.has(receiptKey)) {
      return true; // Already being processed
    }

    pendingReadReceipts.add(receiptKey);

    // Add to batch
    if (!receiptBatch.has(convId)) {
      receiptBatch.set(convId, new Set());
    }
    receiptBatch.get(convId).add(messageId);

    // Clear existing timer and set a new one
    if (batchTimer) {
      clearTimeout(batchTimer);
    }
    batchTimer = setTimeout(sendBatch, BATCH_DELAY);

    return true;
  };
})();

/**
 * Send a WebSocket message
 * @param {Object} message - The message data
 * @returns {boolean} Success status
 */
export const sendWebSocketMessage = (() => {
  // Create a closure to track recent messages by client_temp_id
  const recentMessageIds = new Set();
  const MESSAGE_DEDUP_WINDOW = 5000; // 5 second deduplication window

  return function (message) {
    if (!unifiedSocket || unifiedSocket.readyState !== WebSocket.OPEN) {
      console.error("Cannot send message: WebSocket not connected");
      return false;
    }

    try {
      // Add conversation ID to message if not present
      const enrichedMessage = {
        ...message,
        conversation_id: message.conversation_id || activeConversationId
      };

      // Special handling for chat_message to prevent duplicates and handle null messages
      if (enrichedMessage.type === 'chat_message') {
        const dedupKey = `${enrichedMessage.client_temp_id}`;

        // Check if we've sent this message recently
        if (enrichedMessage.client_temp_id && recentMessageIds.has(dedupKey)) {
          console.warn(`Prevented duplicate message send for client_temp_id: ${enrichedMessage.client_temp_id}`);
          return true; // Return true so UI doesn't show an error
        }

        // For attachment-only messages, handle empty string or null consistently
        // If message is empty string, convert to null
        if (enrichedMessage.message === '') {
          enrichedMessage.message = null;
        }

        // Add to tracking set for deduplication
        if (enrichedMessage.client_temp_id) {
          recentMessageIds.add(dedupKey);

          // Remove from tracking after the deduplication window
          setTimeout(() => {
            recentMessageIds.delete(dedupKey);
          }, MESSAGE_DEDUP_WINDOW);
        }

        // Ensure message always has attachments array
        if (!enrichedMessage.hasOwnProperty('attachments')) {
          enrichedMessage.attachments = [];
        }
      }

      // Send the message
      unifiedSocket.send(JSON.stringify(enrichedMessage));
      return true;
    } catch (error) {
      console.error("Error sending WebSocket message:", error);
      return false;
    }
  };
})(); // Immediately invoked function expression (IIFE) to create closure

/**
 * Mark all messages in a conversation as read
 * @param {string|number} conversationId - The conversation ID
 * @returns {boolean} Success status
 */
export const markConversationAsRead = (conversationId) => {
  const convId = conversationId || activeConversationId;
  if (!convId) {
    console.error("Cannot mark conversation as read: No conversation ID");
    return false;
  }

  if (!unifiedSocket || unifiedSocket.readyState !== WebSocket.OPEN) {
    console.error("Cannot mark conversation as read: WebSocket not connected");
    return false;
  }

  try {
    unifiedSocket.send(JSON.stringify({
      type: 'mark_conversation_read',
      conversation_id: convId
    }));
    return true;
  } catch (error) {
    console.error("Error marking conversation as read:", error);
    return false;
  }
};

/**
 * Request conversations list via WebSocket
 * @returns {boolean} Success status
 */
export const requestConversations = () => {
  if (!unifiedSocket || unifiedSocket.readyState !== WebSocket.OPEN) {
    console.error("Cannot request conversations: WebSocket not connected");
    return false;
  }

  try {
    console.log("Requesting conversations list from WebSocket server");
    unifiedSocket.send(JSON.stringify({
      type: 'request_conversations'
    }));

    // Add timeout to notify if response takes too long
    setTimeout(() => {
      console.log("Checking if conversations were received...");
      if (window.lastConversationsReceived &&
        (Date.now() - window.lastConversationsReceived) < 5000) {
        console.log("Conversations were successfully received");
      } else {
        console.warn("No conversation response received within timeout");
        // Dispatch error event that can be handled by the UI
        dispatchGlobalEvent('conversation-request-timeout', {
          timestamp: Date.now()
        });
      }
    }, 5000);

    return true;
  } catch (error) {
    console.error("Error requesting conversations:", error);
    return false;
  }
};

/**
 * Request unread message counts
 * @returns {boolean} Success status
 */
export const requestUnreadCounts = () => {
  if (!unifiedSocket || unifiedSocket.readyState !== WebSocket.OPEN) {
    console.error("Cannot request unread counts: WebSocket not connected");
    return false;
  }

  try {
    console.log("Explicitly requesting unread counts via WebSocket");
    unifiedSocket.send(JSON.stringify({
      type: 'request_unread_counts'
    }));
    return true;
  } catch (error) {
    console.error("Error requesting unread counts:", error);
    return false;
  }
};

/**
 * Function to explicitly request messages for a conversation
 * @param {string|number} conversationId - The conversation ID
 * @param {number} page - Page number (defaults to 1)
 * @returns {boolean} Success status
 */
export const requestConversationMessages = (conversationId, page = 1) => {
  if (!conversationId) {
    console.error("Cannot request messages: No conversation ID");
    return false;
  }

  if (!unifiedSocket || unifiedSocket.readyState !== WebSocket.OPEN) {
    console.error("Cannot request messages: WebSocket not connected");
    return false;
  }

  try {
    const requestId = `req_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;

    console.log(`Requesting messages for conversation ${conversationId}, page ${page}, request ID: ${requestId}`);
    unifiedSocket.send(JSON.stringify({
      type: 'request_conversation_messages',
      conversation_id: conversationId,
      page: page,
      request_id: requestId
    }));

    // Set a shorter timeout to detect if we don't get a response
    setTimeout(() => {
      dispatchGlobalEvent('conversation-messages-timeout', {
        conversationId,
        requestId,
        timestamp: Date.now()
      });
    }, 3000); // Reduced from 10s to 3s for better UX

    return true;
  } catch (error) {
    console.error("Error requesting conversation messages:", error);
    return false;
  }
};

// ==================== API Functions using Axios ====================

/**
 * Get organization users
 * @returns {Promise<Array>} List of users
 */
export const getOrganizationUsers = async () => {
  try {
    // Fix the endpoint path - `/users/organization/` should be changed to the correct path
    const response = await chatAxios.get('/users/');
    return response.data;
  } catch (error) {
    console.error('Error fetching organization users:', error);
    throw error;
  }
};

/**
 * Upload a file attachment with improved progress tracking
 * @param {File} file - The file to upload
 * @param {Object} options - Upload options
 * @returns {Promise<Object>} Upload result
 */
export const uploadFileAttachment = async (file, options = {}) => {
  try {
    const formData = new FormData();
    formData.append('file', file);

    // Add conversation ID if available
    if (options.conversationId) {
      formData.append('conversation_id', options.conversationId);
    }

    // Add message text if provided
    if (options.text) {
      formData.append('text', options.text);
    }

    // Create XMLHttpRequest for progress tracking
    const xhr = new XMLHttpRequest();
    const promise = new Promise((resolve, reject) => {
      // Use correct endpoint path
      xhr.open('POST', `${BEBase}chat/attachments/upload/`, true);
      xhr.setRequestHeader('Authorization', `Token ${getAuthToken()}`);

      // Set up progress tracking if callback provided
      if (options.onProgress && xhr.upload) {
        xhr.upload.onprogress = (event) => {
          // Call the progress callback with the event
          options.onProgress(event);
        };
      }

      xhr.onload = function () {
        if (this.status >= 200 && this.status < 300) {
          try {
            const response = JSON.parse(xhr.response);
            // If successful, send 100% progress update
            if (options.onProgress) {
              options.onProgress({ loaded: 100, total: 100, lengthComputable: true });
            }
            resolve(response);
          } catch (err) {
            reject(new Error(`Invalid response: ${xhr.response}`));
          }
        } else {
          reject(new Error(`Upload failed with status: ${this.status}`));
        }
      };

      xhr.onerror = function () {
        reject(new Error('Upload request failed'));
      };

      xhr.send(formData);
    });

    return promise;
  } catch (error) {
    console.error('File upload error:', error);
    throw error;
  }
};

/**
 * Register a Firebase Cloud Messaging token
 * @param {string} token - The FCM token
 * @returns {Promise<Object>} Response data
 */
export const saveNotificationToken = async (token) => {
  try {
    const response = await chatAxios.post('/register-fcm-token/', {
      token: token,
      type: 'web',
      device_name: navigator.userAgent.substring(0, 100)
    });

    return response.data;
  } catch (error) {
    console.error('Error saving FCM token:', error);
    return false;
  }
};

export const swipe = async (token) => {
  try {
    const response = await chatAxios.post('/swipe/', {
      token: token,
      type: 'web',
      device_name: navigator.userAgent.substring(0, 100)
    });

    return response.data;
  } catch (error) {
    console.error('Error saving FCM token:', error);
    return false;
  }
};

export const undo = async (token) => {
  try {
    const response = await chatAxios.post('/undo/', {
      token: token,
      type: 'web',
      device_name: navigator.userAgent.substring(0, 100)
    });

    return response.data;
  } catch (error) {
    console.error('Error saving FCM token:', error);
    return false;
  }
};

export const list_admin_users = async (token) => {
  try {
    const response = await chatAxios.post('/list_admin_users/', {
      token: token,
      type: 'web',
      device_name: navigator.userAgent.substring(0, 100)
    });

    return response.data;
  } catch (error) {
    console.error('Error saving FCM token:', error);
    return false;
  }
};

export const list_investor_users = async (token) => {
  try {
    const response = await chatAxios.post('/list_investor_users/', {
      token: token,
      type: 'web',
      device_name: navigator.userAgent.substring(0, 100)
    });

    return response.data;
  } catch (error) {
    console.error('Error saving FCM token:', error);
    return false;
  }
};

/**
 * Deactivate a Firebase Cloud Messaging token
 * @param {string} token - The FCM token
 * @returns {Promise<boolean>} Success status
 */
export const deactivateFCMToken = async (token) => {
  try {
    if (!token) {
      console.warn('No FCM token provided to deactivate');
      return false;
    }

    const response = await chatAxios.post('/deactivate-fcm-token/', {
      token: token,
      type: 'web'
    });

    return response.data.success || true;
  } catch (error) {
    console.error('Error deactivating FCM token:', error);
    return true; // Always return true on error to allow logout to continue
  }
};

// Export connection status for global checking
export const getConnectionStatus = () => window.chatConnectionStatus || 'disconnected';

// Initialize
window.chatConnectionStatus = 'disconnected';

/**
 * Make markConversationAsRead available globally
 * This helps ensure consistent behavior across components
 */
window.markConversationAsRead = markConversationAsRead;

// Make this function available globally for direct access
window.sendWebSocketMessage = sendWebSocketMessage;
window.requestUnreadCounts = requestUnreadCounts;

/**
 * Create a new group conversation via WebSocket
 * @param {Object} groupData - Group data including name and participant_ids
 * @returns {boolean} Success status
 */
export const createGroupConversation = (groupData) => {
  if (!groupData.name || !groupData.participant_ids || !Array.isArray(groupData.participant_ids)) {
    console.error("Invalid group data: requires name and participant_ids array");
    return false;
  }

  return sendWebSocketMessage({
    type: 'create_group',
    name: groupData.name,
    participant_ids: groupData.participant_ids
  });
};

/**
 * Update an existing group conversation via WebSocket
 * @param {string|number} conversationId - The conversation ID 
 * @param {Object} updateData - The data to update (name, etc)
 * @returns {boolean} Success status
 */
export const updateGroupConversation = (conversationId, updateData) => {
  if (!conversationId) {
    console.error("Cannot update group: No conversation ID provided");
    return false;
  }

  return sendWebSocketMessage({
    type: 'update_group',
    conversation_id: conversationId,
    ...updateData
  });
};

/**
 * Add members to a group conversation via WebSocket
 * @param {string|number} conversationId - The conversation ID
 * @param {Array<string|number>} userIds - User IDs to add
 * @returns {boolean} Success status
 */
export const addGroupMembers = (conversationId, userIds) => {
  if (!conversationId || !userIds || !userIds.length) {
    console.error("Cannot add members: Missing conversation ID or user IDs");
    return false;
  }

  return sendWebSocketMessage({
    type: 'add_group_members',
    conversation_id: conversationId,
    user_ids: userIds
  });
};

/**
 * Remove a member from a group conversation via WebSocket
 * @param {string|number} conversationId - The conversation ID
 * @param {string|number} userId - User ID to remove
 * @returns {boolean} Success status
 */
export const removeGroupMember = (conversationId, userId) => {
  if (!conversationId || !userId) {
    console.error("Cannot remove member: Missing conversation ID or user ID");
    return false;
  }

  return sendWebSocketMessage({
    type: 'remove_group_member',
    conversation_id: conversationId,
    user_id: userId
  });
};

/**
 * Leave a group conversation via WebSocket
 * @param {string|number} conversationId - The conversation ID
 * @returns {boolean} Success status
 */
export const leaveGroup = (conversationId) => {
  if (!conversationId) {
    console.error("Cannot leave group: No conversation ID provided");
    return false;
  }

  return sendWebSocketMessage({
    type: 'leave_group',
    conversation_id: conversationId
  });
};

/**
 * Delete a conversation
 * @param {string|number} conversationId - The conversation ID
 * @returns {boolean} Success status
 */
export const deleteConversation = (conversationId) => {
  if (!conversationId) {
    console.error("Cannot delete conversation: No conversation ID provided");
    return false;
  }

  return sendWebSocketMessage({
    type: 'delete_conversation',
    conversation_id: conversationId
  });
};

/**
 * Leave a conversation
 * @param {string|number} conversationId - The conversation ID
 * @returns {boolean} Success status
 */
export const leaveConversation = (conversationId) => {
  if (!conversationId) {
    console.error("Cannot leave conversation: No conversation ID provided");
    return false;
  }

  return sendWebSocketMessage({
    type: EVENTS.LEAVE_CONVERSATION,
    conversation_id: conversationId
  });
};

/**
 * Add members to a conversation
 * @param {string|number} conversationId - The conversation ID
 * @param {Array<string|number>} memberIds - User IDs to add
 * @returns {boolean} Success status
 */
export const addConversationMembers = (conversationId, memberIds) => {
  if (!conversationId || !memberIds || !memberIds.length) {
    console.error("Cannot add members: Missing conversation ID or member IDs");
    return false;
  }

  return sendWebSocketMessage({
    type: EVENTS.ADD_MEMBERS,
    conversation_id: conversationId,
    member_ids: memberIds
  });
};

/**
 * Remove members from a conversation
 * @param {string|number} conversationId - The conversation ID
 * @param {Array<string|number>} memberIds - User IDs to remove
 * @returns {boolean} Success status
 */
export const removeConversationMembers = (conversationId, memberIds) => {
  if (!conversationId || !memberIds || !memberIds.length) {
    console.error("Cannot remove members: Missing conversation ID or member IDs");
    return false;
  }

  return sendWebSocketMessage({
    type: EVENTS.REMOVE_MEMBERS,
    conversation_id: conversationId,
    member_ids: memberIds
  });
};

export const getNotificationsAPI = async (page = 1, filters = {}) => {
  try {
    const params = { page };
    if (filters.is_read !== undefined) {
      params.is_read = filters.is_read;
    }
    if (filters.type) {
      params.type = filters.type;
    }
    const response = await chatAxios.get('/notifications/', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching notifications:', error);
    throw error;
  }
};

export const markNotificationReadAPI = async (notificationId) => {
  try {
    const response = await chatAxios.post(`/notifications/${notificationId}/mark-read/`);
    return response.data;
  } catch (error) {
    console.error('Error marking notification as read:', error);
    throw error;
  }
};

export const markAllNotificationsReadAPI = async () => {
  try {
    const response = await chatAxios.post('/notifications/mark-all-read/');
    return response.data;
  } catch (error) {
    console.error('Error marking all notifications as read:', error);
    throw error;
  }
};

